<template>
  <TemplatePageGrid
    :items="target === 'manual'
    ? notificationAdminManualGrid
    : target === 'triggered' ? notificationAdminTriggeredGrid : notificationAdminProjectGrid"
    :page-data="target === 'manual' ? pageData : target === 'triggered' ? pageData2 : pageData3"
    :loading="loadingAnimation"
  >
    <template v-slot:buttons>
      <SettingsPushNotificationsModal
        v-if="
          $userCheckAccess({ checkUserType: 'superadmin' }) ||
          $userCheckAccess({ abilities: 'edit_notifications' })
        "
        modal-type="create"
        :onDownloadPageData="onDownloadPageData"
        :type="target"
      />
    </template>
    <template v-slot:filters v-if="target === 'triggered'">
      <BaseInput
        v-model="triggerFilter"
        :items="triggersList"
        item-text="text"
        item-value="value"
        type="select"
        :placeholder="localStorage.translations.pages['setting-push_notifications'].main['trigger']"
        filter
        multiple
        hide-details
        @change="onFilterChange"
      />
    </template>
    <SettingsPushNotificationsTable
      :items="target === 'manual'
      ? notificationAdminManualGrid
      : target === 'projects' ? notificationAdminProjectGrid : notificationAdminTriggeredGrid"
      :onDownloadPageData="onDownloadPageData"
      :target="target"
    />
  </TemplatePageGrid>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import SettingsPushNotificationsTable from 'components/setting/pushNotifications/SettingsPushNotificationsTable'
import SettingsPushNotificationsModal from 'components/setting/pushNotifications/SettingsPushNotificationsModal'
import page from "@/store/modules/page";

export default {
  name: 'settingsPushNotificationsEdit',
  components: {
    SettingsPushNotificationsTable,
    SettingsPushNotificationsModal,
  },
  data() {
    return {
      triggerFilter: [],
    }
  },
  created() {
    this.onDownloadPageData()
  },
  watch: {
    '$route.query'() {
      this.onDownloadPageData()
    },
  },
  computed: {
    ...mapState(['configData']),
    ...mapGetters('notificationAdminManual', ['notificationAdminManualGrid', 'pageData']),
    ...mapGetters('notificationAdminProject', {
      pageData3: 'pageData',
      notificationAdminProjectGrid: 'notificationAdminProjectGrid',
      notificationAdminProjectTriggersList: 'notificationAdminProjectTriggersList',
    }),
    ...mapGetters('notificationAdminTriggered', {
      pageData2: 'pageData',
      notificationAdminTriggeredGrid: 'notificationAdminTriggeredGrid',
      notificationAdminTriggeredTriggersList: 'notificationAdminTriggeredTriggersList',
    }),
    ...mapGetters(['loadingAnimation']),
    target() {
      return this.$route.name === 'settingsPushNotificationsManual'
        ? 'manual'
        : this.$route.name === 'settingsPushNotificationsProjects'
          ? 'projects'
          : 'triggered'
    },
    triggersList() {
      let data = []
      let list = this.target === 'projects'
        ? this.notificationAdminProjectTriggersList
        : this.notificationAdminTriggeredTriggersList
      for (let trigger of list) {
        let obj = {
          value: trigger.value,
        }
        const transitionTarget =
          this.localStorage.translations.pages['setting-push_notifications'].triggers[trigger.value]
        obj.text = transitionTarget ? transitionTarget : trigger.text
        data.push(obj)
      }
      return data
    },
  },
  methods: {
    ...mapActions('notificationAdminManual', ['onNotificationAdminManualGrid']),
    ...mapActions('notificationAdminTriggered', [
      'onNotificationAdminTriggeredGrid',
      'onNotificationAdminTriggeredTriggersList',
    ]),
    ...mapActions('notificationAdminProject', [
      'onNotificationAdminProjectGrid',
      'onNotificationAdminProjectTriggersList',
      'onNotificationAdminProjectProjectsList',
    ]),
    ...mapMutations(['setLoadingAnimation']),

    async onDownloadPageData() {
      console.log('onDownloadPageData')
      this.setLoadingAnimation(true)
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.filter) {
        data.filter = this.$route.query.filter
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      await this[
        this.target === 'manual'
          ? 'onNotificationAdminManualGrid'
          : this.target === 'projects'
            ? 'onNotificationAdminProjectGrid'
            : 'onNotificationAdminTriggeredGrid'
      ](data)
        .then(() => {
          if (this.target === 'triggered')
            this.onNotificationAdminTriggeredTriggersList()
          if (this.target === 'projects') {
            this.onNotificationAdminProjectTriggersList()
            this.onNotificationAdminProjectProjectsList()
          }
          this.setLoadingAnimation(false)
        })
        .catch(() => {
          this.setLoadingAnimation(false)
        })
    },

    onFilterChange() {
      this.$routerPushQueryParams('filter', this.triggerFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-wrap {
  gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    gap: 12px;
  }
}
</style>
